import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ModalInfo, Spinner } from 'shared/components';

const AvailableRoomsModal = (props) => {
  const { t } = useTranslation();
  return (
    <ModalInfo
      modalIsOpen={props.modalAvailableRoomsOpen}
      closeModal={props.toggleAvailableRoomsModal}
      headerTitle={t('rosters.availableRoomsModal.title')}
      onSubmit={props.toggleAvailableRoomsModal}
      saveLabel={t('common.labels.back')}
      className="available-rooms-modal">
      {props.loadingRoomsRosters ? (
        <Spinner />
      ) : (
        <React.Fragment>
          <div className="location">
            {props.location.name}
            {props.location.area && props.location.area.length > 0 && `, ${props.location.area}`}
          </div>
          {props.locationEventRoomRosters.map((room) => (
            <React.Fragment key={room.id}>
              <div className="room">
                {room.name} ({room.assigned}/{room.capacity})
              </div>
              <div>
                <span className="room-info">
                  {room.type ? room.type : t('testCenter.roomDashboard.noTypeLabel')}
                </span>
                {room.timing && (
                  <span className="room-info">{props.mappedRoomTiming[room.timing]?.name}</span>
                )}
                {room.singleRoomFlag && (
                  <span className="room-info">{t('roomBuilder.singleRoom.infoValue')}</span>
                )}
                <span className="room-info">
                  {room.onlineFlag ? t('common.labels.online') : t('common.labels.paper')}
                </span>
              </div>
            </React.Fragment>
          ))}
        </React.Fragment>
      )}
    </ModalInfo>
  );
};

AvailableRoomsModal.propTypes = {
  modalAvailableRoomsOpen: PropTypes.bool.isRequired,
  locationEventRoomRosters: PropTypes.arrayOf(PropTypes.shape({})),
  toggleAvailableRoomsModal: PropTypes.func,
  location: PropTypes.shape({}),
};

export default AvailableRoomsModal;
